import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Input,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
  useBreakpointValue,
  Select,
  Link,
} from "@chakra-ui/react";
import axios from "axios";
import * as mod from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export const MootAllApplication = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchInstitute, setSearchInstitute] = useState("");
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [mootusercount, setMootusercount] = useState(0);

  const toast = useToast();
  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const navigate = useNavigate();
  const SIDEBAR_WIDTH = "250px";

  // Add this function inside MootAllApplication component
  const exportToExcel = () => {
    // Prepare data for Excel
    const dataForExcel = filteredUsers.map((user, index) => ({
      "S.No": index + 1,
      MootCourtId: user?.MootCourtId,
      Institution: user?.institution,
      Email: user?.email,
      Phone: user?.mobile,
      Date: new Date(user?.createdAt).toLocaleDateString("en-IN"),
    }));

    // Add total applications as first row
    dataForExcel.unshift({
      "S.No": "",
      MootCourtId: "",
      Institution: "Total Applications",
      Email: mootusercount.totalMootUSer || filteredUsers.length,
      Phone: "",
      Date: "",
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

    // Create workbook and add worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Moot Applicants");

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save file
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "MootApplicants.xlsx");
  };

  useEffect(() => {
    fetchAllMootUsers();
    fetchAllMootUsersCounts();
  }, []);

  const fetchAllMootUsersCounts = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/MootUser/mootuser_count`,
        config
      );
      setMootusercount(data.data);
    } catch (error) {
      toast({
        title: "Error fetching users",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchAllMootUsers = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/MootUser/all_mootuser`,
        config
      );

      setUsers(data.users);
      setFilteredUsers(data.users);

      const dates = [
        ...new Set(
          data.users.map((u) =>
            new Date(u.createdAt).toLocaleDateString("en-IN")
          )
        ),
      ];
      setAvailableDates(dates);
    } catch (error) {
      toast({
        title: "Error fetching users",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUserClick = (userId) => {
    navigate(`/admin/moot-user/${userId}`);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchInstitute(value);

    const filtered = users.filter((user) => {
      const institutionMatch = user.institution?.toLowerCase().includes(value);
      const emailMatch = user.email?.toLowerCase().includes(value);
      const mobileMatch = user.mobile?.toLowerCase().includes(value);
      const dateMatch = new Date(user.createdAt)
        .toLocaleDateString("en-IN")
        .toLowerCase()
        .includes(value);

      return institutionMatch || dateMatch || emailMatch || mobileMatch;
    });

    setFilteredUsers(filtered);
  };

  const handleDateFilter = (e) => {
    const value = e.target.value;
    setSelectedDate(value);

    if (!value) {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) => new Date(user.createdAt).toLocaleDateString("en-IN") === value
      );
      setFilteredUsers(filtered);
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Box
        mt="80px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
        p={4}
        minH="100vh"
        bg="gray.50"
      >
        <Container maxW="container.xl" p={0}>
          <Text
            fontSize={{ base: "xl", md: "2xl" }}
            mb={4}
            bg="#D29B3F"
            p={3}
            borderRadius="md"
            fontWeight="bold"
          >
            Total - {mootusercount?.totalMootUSer} Moot Applicants
          </Text>

          {/* <Flex
            direction={{ base: "column", md: "row" }}
            gap={4}
            mb={4}
            alignItems={{ base: "stretch", md: "center" }}
          >
            <Input
              placeholder="Search by Institution Name"
              value={searchInstitute}
              onChange={handleSearch}
              maxW="400px"
              w="100%"
            />
            <Select
              placeholder="All Dates"
              value={selectedDate}
              onChange={handleDateFilter}
              maxW="250px"
              w="100%"
            >
              {availableDates.map((date) => (
                <option key={date} value={date}>
                  {date}
                </option>
              ))}
            </Select>
          </Flex> */}
          <Flex mb={4} gap={4} direction={{ base: "column", md: "row" }}>
            <Button colorScheme="green" onClick={exportToExcel}>
              Export to Excel
            </Button>
            <Input
              placeholder="Search by Institution Name, email, mobile"
              value={searchInstitute}
              onChange={handleSearch}
              maxW="400px"
              w="100%"
            />
            <Select
              placeholder="All Dates"
              value={selectedDate}
              onChange={handleDateFilter}
              maxW="250px"
              w="100%"
            >
              {availableDates.map((date) => (
                <option key={date} value={date}>
                  {date}
                </option>
              ))}
            </Select>
          </Flex>

          <Box overflowX="auto" bg="white" borderRadius="md" boxShadow="md">
            <Table variant="striped" colorScheme="gray" size="sm">
              <Thead bg="blue.100">
                <Tr>
                  <Th>S.No</Th>
                  <Th>MootCourtId</Th>
                  <Th>Institution</Th>
                  <Th>Email</Th>
                  <Th>Phone</Th>
                  <Th>Date</Th>
                  <Th>Memorial</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredUsers.length === 0 ? (
                  <Tr>
                    <Td colSpan="7" textAlign="center" py={6}>
                      No users found.
                    </Td>
                  </Tr>
                ) : (
                  filteredUsers.map((user, index) => (
                    <Tr key={user._id}>
                      <Td>{index + 1}</Td>
                      <Td>{user?.MootCourtId}</Td>
                      <Td>{user?.institution}</Td>
                      <Td>{user?.email}</Td>
                      <Td>{user?.mobile}</Td>
                      <Td>
                        {new Date(user?.createdAt).toLocaleDateString("en-IN")}
                      </Td>
                      <Td>
                        {/* {user?.memorial} */}
                        {user.memorial ? (
                          <Link href={user.memorial} isExternal>
                            <Button colorScheme="blue" size="sm">
                              memorial
                            </Button>
                          </Link>
                        ) : (
                          <Text>No uploaded</Text>
                        )}
                      </Td>
                      <Td>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          onClick={() => handleUserClick(user._id)}
                        >
                          View
                        </Button>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </Box>
        </Container>
      </Box>
    </>
  );
};
